import { store } from '../store.js';

export default {
  data() {
    return {
      storage: store.storage,
      isSubmit: false,
      isSubmitDelete: false,
      isSubmitGet: false,
      errorMsgList: {}
    }
  },
  computed: {
    ionicStorage() {
      return this.storage.ionic;
    },
    negoceImg() {
      return this.$apiDomain + '/imgs/negoce/' + this.negoceId + (this.isAppro ? '_appro' : '');
    }
  },
  methods: {
    async updateUserFromResponse(responseUser) {
      if(! (this.user && this.user.id == responseUser.id)) {
        // debug console.error('update user failed');
        return false; // switch recolte occured
      }
      store.state.user = responseUser;
      await this.ionicStorage.set('user', responseUser);
      return true;
    },
    setJson(oldJson, newJson) {
        for (const key in oldJson) {
            if (newJson[key] !== undefined) {
                oldJson[key] = JSON.parse(JSON.stringify(newJson[key]));
            }
        }
    },
    mergeJson(oldJson, newJson) {
        for (const key in newJson) {
            oldJson[key] = JSON.parse(JSON.stringify(newJson[key]));
        }
    },
    getPath(path, urlParams) {
      path += '?user_id=';
      if(this.user && this.user.id){
        path += this.user.id;
      }
      if(this.state && this.state.app_token){
          path += '&app_token=' + encodeURIComponent(this.state.app_token);
      }
      if (urlParams) {
          for (const key in urlParams) {
              path += '&' + key + '=' + encodeURIComponent(urlParams[key]);
          }
      }
      return path;
    },
    sendTrackEvent(trackInfos){
      var fetchInit = this.$getFetchInit('POST', true);
      fetchInit.body = trackInfos;
      fetch(this.$apiDomain + this.getPath('/track'), fetchInit).catch(error => {});
    },
    async handleLogin(fetchInit, callPath){
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        // debug console.log('login show plashScreen');
        this.$splashScreen('show');
        response.date = new Date().getTime();
        await Promise.all(
          [
            'app_token',
            'user',
            'multi',
            'referentiel',
            'cours',
            'negoce',
            'histo',
            'live',
            'quiz_data',
            'date',
          ].map(
            async (key) => {
              let val = response[key == 'quiz_data' ? 'quiz' : key];
              if(key == 'multi'){
                val = Object.keys(val).length ? val : {};
              }
              await this.ionicStorage.set(key, val);
        }));
        window.location.href = '/';
      } catch(error) {
        if (error.status == 401) {
          this.setErrorMsgList('errorLogin', 'Vos identifiants sont incorrects');
          this.handleError(null);
        } else {
          this.handleError(error, 'de la connexion');
        }
      }
    },
    async handleRequest(url, init) {
      var response = await fetch(url, init);
      return this.handleResponse(response);
    },
    handleResponse(response) {
        if (!response.ok) {
            return response.text().then(text => {
                if (text) {
                    return Promise.reject({
                        is_custom: true,
                        status: response.status,
                        message: text
                    });
                } else {
                    return Promise.reject({
                        status: response.status,
                        message: "code: " + response.status
                    });
                }
            });
        }
        return response.json();
    },
    handleError(error, defaultMsg, showAlert) {
      var isScrollTop = true;
      if (error) {
        if (error.status == 410) {
          this.$ons.notification.alert({
            modifier: this.$mdModifier,
            title: 'Attention !',
            message: "Vous devez mettre à jour votre application pour continuer à l'utiliser",
            buttonLabels: ['Mettre à jour'],
            callback: function () {
              this.$redirectToStore();
            }.bind(this)
          });
        } else if (error.status == 401) {
          this.logout();
          return; // keep spinning
        } else {
          var msg = 'Erreur lors ' + (defaultMsg ? defaultMsg : 'de la sauvegarde');
          if (error.is_custom) {
            msg = error.message;
          } else if (error.status == 409) {
            this.$emit('call-api');
            msg += '. Vos données ne sont pas à jour. Veuillez recommencer.'
          } else if (error.message == 'Failed to fetch' || error.message == 'The Internet connection appears to be offline.') {
            msg += '. Veuillez vérifier votre connexion internet.'
          } else {
            msg += ' (' + error.message + ')';
          }
          if (showAlert) {
            this.$ons.notification.alert({
              modifier: this.$mdModifier,
              title: 'OUPS !',
              message: msg
            });
            isScrollTop = false;
          } else {
            this.setErrorMsgList('errorServer', msg);
          }
        }
      }
      isScrollTop && this.$scrollTop();
      this.isSubmit = false;
      this.isSubmitDelete = false;
      this.isSubmitGet = false;
    },
    async logout() {
      // debug console.log('logout show plashScreen');
      this.$splashScreen('show');
      const onboarding = await this.ionicStorage.get('onboarding');
      await this.ionicStorage.clear();
      await this.ionicStorage.set('onboarding', onboarding);

      var pushToken = localStorage.getItem('push_token');
      // track + suppression des cookies si ! isAdmin
      var fetchInit = this.$getFetchInit('POST', true);
      if (pushToken) {
          var fd = new FormData();
          fd.append('push_token', pushToken);
          fetchInit.body = fd;
      }
      await fetch(this.$apiDomain + '/logout', fetchInit).catch(error => {});
      window.location.reload();
    },
    nextInput(inputRef) {
      if (this.$refs[inputRef] && this.$refs[inputRef].$el.querySelector('input')){
        this.$refs[inputRef].$el.querySelector('input').focus();
      }
    },
    showKeyboard() {
      if (this.$ons.platform.isWebView() && this.$ons.platform.isIOS()) {
        Keyboard.show();
      }
    },
    closeKeyboard(event) {
      event.target.blur();
      this.$ons.platform.isWebView() && Keyboard.hide();
    },
    resetErrorMsgList() {
      for (const inputRef in this.errorMsgList) {
        if (this.$refs[inputRef]) {
          var refList = this.$refs[inputRef];
          if(! Array.isArray(refList)){
            refList = [refList];
          }
          for (let i = 0; i < refList.length; i++) {
            var refItem = refList[i];
            if(refItem && refItem.$el){
              refItem.$el.querySelector('input,select') && refItem.$el.querySelector('input,select').setCustomValidity('');
              refItem.$el.querySelector('label') && refItem.$el.querySelector('label').classList.remove('label--invalid');
            } else if(refItem && refItem.tagName == 'CANVAS'){
              refItem.classList.remove('label--invalid');
            }
          }
        }
      }
      this.errorMsgList = {};
    },
    setErrorMsgList(inputRef, errorMsg) {
      if(errorMsg){
        this.$set(this.errorMsgList, inputRef, errorMsg.split("\n"));
      }
      var refList = this.$refs[inputRef];
      if(! Array.isArray(refList)){
        refList = [refList];
      }
      for (let i = 0; i < refList.length; i++) {
        var refItem = refList[i];
        if(refItem && refItem.$el){
          refItem.$el.querySelector('input,select') && refItem.$el.querySelector('input,select').setCustomValidity('custom');
          refItem.$el.querySelector('label') && refItem.$el.querySelector('label').classList.add('label--invalid');
        } else if(refItem && refItem.tagName == 'CANVAS'){
          refItem.classList.add('label--invalid');
        }
      }
    },
    getNegoceAcces(negoce, negoceId, idUser){
      var list = [];
      if(! idUser){
        idUser = this.user.id;
      }
      idUser = idUser.toString();
      idUser = idUser.substring(0, idUser.length - 4);
      for (let i = 0; i < negoce.length; i++) {
        var negoceItem = negoce[i];
        if(negoceItem.acces && negoceItem.acces != idUser){
          continue;
        }
        if(negoceItem.id == negoceId){
          return negoceItem;
        }
        list.push(negoceItem);
      }
      if(! negoceId){
        return list;
      }
    },
    getCampagneNotifCount(ventes, negoce, notifState){
      var count = 0;
      for (const refCulture in ventes) {
        for (const refDestination in ventes[refCulture]) {
          var strategie = ventes[refCulture][refDestination];
          if (!strategie.done) {
            continue;
          }
          count += (this.getCultureNotifCount(strategie.done, negoce, refCulture, refDestination, notifState) ? 1 : 0);
        }
      }
      return count;
    },
    getCultureNotifCount(listVentes, negoce, refCulture, refDestination, notifState){
      var notifStateList = [];
      if(notifState[refCulture] && notifState[refCulture][refDestination]){
        notifStateList = notifState[refCulture][refDestination];
      }
      var isTech = negoce[0] && negoce[0].is_tech;
      var negoceList = negoce.map(item => { return item.id });
      var dateNow = new Date().getTime() / 1000;
      return listVentes.reduce(function (sum, vente) {
        if(vente.negoce){
          if(vente.otp_missing){
            sum += 1;
          } else if(isTech){
            if(vente.etat == 'demande'){
              sum += 1;
            } else if(! negoceList.includes(vente.negoce) && ! notifStateList.includes(vente.id)){
              sum += 1;
            }
          } else {
            if(vente.etat == 'contrat' && (vente.is_signe === false || vente.is_signe_otp === false)
            && ! (vente.signe_expire && vente.signe_expire < dateNow)){
              sum += 1;
            }
          }
        }
        return sum;
      }, 0)
    },
    normalize(value){
      // Test regex: [^A-Z0-9\n \.'"-/&éèïç@]
      return value.replace(/[ \.'"-/&]/g, '').toLowerCase().replace(/[èé]/g, 'e').replace(/ï/g, 'i').replace(/ç/g, 'c').replace(/@/g, 'a');
    },
    getFermeLabel(user){
      return user.ferme.nom ? user.ferme.nom : user.nom.toUpperCase() + ' ' + user.prenom;
    },
    evalDate(lignes){
      const content = [];
      const dateNow = new Date(this.now);
      for (let i = 0; i < lignes.length; i++) {
        let ligne = lignes[i];
        const dateEval = ligne.match(/{{ ([0-9]+) }}/g);
        for (let j = 0; j < (dateEval ? dateEval.length : 0); j++) {
          let date = new Date(parseInt(dateEval[j].replace(/[^0-9]/g, '')) * 1000);
          let interval = Math.ceil((date - dateNow) / (60 * 1000));
          let dateLabel;
          if(interval > 60){
            dateLabel = Math.floor(interval / 60) + 'h';
            interval = interval%60;
            dateLabel += interval.toString().padStart(2, '0') + 'min';
          } else {
            dateLabel = Math.max(interval, 1) + 'min';
          }
          ligne = ligne.replace(dateEval[j], dateLabel);
        }
        content.push(ligne);
      }
      return content;
    },
    openFlashLink(event){
      if (event.target.tagName === 'A') {
        event.stopPropagation();
        event.preventDefault();
        if (typeof cordova !== 'undefined') {
          cordova.InAppBrowser.open(event.target.href, '_system');
        } else {
          window.open(event.target.href, '_blank');
        }
        return;
      }
    }
  }
}